module.exports = "/build/web/svg/eredivisie-blue.7998706040e143e7ddd4485242bcedff.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/eredivisie-blue.svg
// module id = 154
// module chunks = 24